import React from 'react'
import HTMLReactParser from 'html-react-parser'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { FlexContainer, createForm, TitleOrangeBold, isEmpty } from 'heliocor-ui'

import { getCompanyStructureFields, getPersonStructureFields } from '../../utils/structure'
import { CategoryDescription } from '../../common/Wizard/styles'
import { isCategoryConditionSatisfied } from './helpers'

const OwnerDetails = ({
    type, 
    cpCategories = [],
    errorHandler,
    isEdit,
    inputChangedHandler,
    values,
    errors,
    companyLookUpInstructions,
    sliderMax,
    formattingOptions,
    postErrors,
    postErrorHandler,
    supportedRegions,
    country,
    cleanValues,
    isLoading,
    isRequest
}) => {
    const { t } = useTranslation()
    const kycType = useSelector(state => state.settings.kycType)

    const fieldMapper = {
        PERSON: (fields) => getPersonStructureFields({fields, kycType, t}),
        COMPANY: (fields) => getCompanyStructureFields({fields, supportedRegions, country, kycType, t})
    }[type]

    const isCategoryVisible = cat => {
        const dependency = cat?.dependencies || {}
        if(isEmpty(dependency)) return true

        return isRequest ? dependency.CAFE_PHASE_2 : dependency.CAFE_PHASE_1
    }

    const isCategoryDependencySatisfied = cat => {
        const dependency = cat?.dependencies || {}
        return isCategoryConditionSatisfied({dependency, values, isRequest})
    }

    return (
        <>
            {cpCategories
                .filter(isCategoryVisible)
                .filter(isCategoryDependencySatisfied)
                .map(({ description = '', name, fields, dependencies }) => {
                
                return (
                    <FlexContainer key={name} column margin={"2rem 0 0 0"}>
                        <TitleOrangeBold value={t(name)} padding={"0 1rem"} margin={"0"}/>
                        {description && (
                            <CategoryDescription padding={"0 1rem"}>
                                {HTMLReactParser(description)}
                            </CategoryDescription>
                        )}
                        <FlexContainer>
                            {createForm({
                                fields: fieldMapper(fields),
                                props: {
                                    values,
                                    errors,
                                    inputChangedHandler,
                                    companyLookUpInstructions,
                                    formattingOptions,
                                    postErrorHandler,
                                    postErrors,
                                    errorHandler,
                                    sliderMax,
                                    cleanValues,
                                    isLoading,
                                    isEdit,
                                    noFocus: true,
                                    t
                                },
                            })}
                        </FlexContainer>

                    </FlexContainer>
                )
            })}
        </>
    )
}

export { OwnerDetails }
